export default {
  namespaced: true,
  state: {
    activeTab: "tasks",
    expandedFicheId: null,
    categoryFilter: null,
  },
  mutations: {
    SET_TAB(state, tab) { state.activeTab = tab },
    SET_EXPANDED_FICHE(state, id) { state.expandedFicheId = id },
    SET_CATEGORY_FILTER(state, cat) { state.categoryFilter = cat },
  },
}
